import React from 'react';
import { Bar } from 'react-chartjs-2';
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Card } from 'react-bootstrap';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DashboardCnpjYearComparisonChart = ({ comparisons = [] }) => {
    if (!comparisons.length) {
        return (
            <Card className="kpi-section-card mt-4">
                <Card.Body>
                    <Card.Title className="kpi-section-title" as="h5">Comparativo de resultados por ano</Card.Title>
                    <p className="kpi-section-subtitle">Ainda não há inspeções com resultado e data para compor o comparativo.</p>
                </Card.Body>
            </Card>
        );
    }

    const data = {
        labels: comparisons.map((item) => item.year.toString()),
        datasets: [
            { label: 'Aprovações', data: comparisons.map((item) => item.approved), backgroundColor: '#28a745' },
            { label: 'Aprovações com recomendações', data: comparisons.map((item) => item.recommended), backgroundColor: '#ffc107' },
            { label: 'Reprovações', data: comparisons.map((item) => item.rejected), backgroundColor: '#dc3545' }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom' },
            tooltip: { mode: 'index', intersect: false }
        },
        scales: {
            x: { stacked: false, title: { display: true, text: 'Ano da inspeção' } },
            y: { beginAtZero: true, ticks: { precision: 0 }, title: { display: true, text: 'Total de laudos' } }
        }
    };

    return (
        <Card className="kpi-section-card mt-4">
            <Card.Body>
                <Card.Title className="kpi-section-title" as="h5">Comparativo de resultados por ano</Card.Title>
                <p className="kpi-section-subtitle">Histórico consolidado do CNPJ por resultado de inspeção.</p>
                <div style={{ height: 340 }} className="mt-3">
                    <Bar data={data} options={options} />
                </div>
            </Card.Body>
        </Card>
    );
};

export default DashboardCnpjYearComparisonChart;
